import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import SquareIcon from '@mui/icons-material/Square';
import { Box, Button, IconButton } from '@mui/material';
import React from 'react';
import { buildEventTab, buildGeneralTab, buildHiddenTab, buildStyleTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { FormTooltip } from '../WidgetForm/Components';
import { callEventFunction, defaultWidgetLabelProvider, handleWidgetUpdate, makeNewConfigUnique, renderForm } from '../WidgetForm/Utils';
import { WidgetHandler } from '../WidgetHandler';
import { icons } from '../icons/icons';
import { type } from './types';
const WidgetFormButton = (props) => {
    var _a, _b, _c, _d, _e, _f;
    let StartIcon;
    if (props.config.icon) {
        const customIcons = (_a = props.rootParams.globalWidgetConfig) === null || _a === void 0 ? void 0 : _a.buttonIcons;
        StartIcon = customIcons ? customIcons[props.config.icon] : icons[props.config.icon];
    }
    const commonProps = {
        onClick: () => {
            var _a;
            if ((_a = props.config.event) === null || _a === void 0 ? void 0 : _a.onClick) {
                const handler = new WidgetHandler(props);
                callEventFunction(props, 'onClick', 'handler', handler);
                if (handler.status.update) {
                    props.update();
                }
                renderForm(props);
            }
        },
        sx: {
            width: ((_b = props.config.style) === null || _b === void 0 ? void 0 : _b.width) != null ? '100%' : undefined,
        },
        color: 'primary',
        disabled: props.config.disabled,
        tabIndex: props.editMode ? -1 : undefined,
        autoFocus: (_c = (!props.editMode && props.config.autoFocus)) !== null && _c !== void 0 ? _c : false,
    };
    const buttonElement = ((_d = props.config.style) === null || _d === void 0 ? void 0 : _d.type) === 'iconButton' ? (React.createElement(IconButton, Object.assign({}, commonProps, { "aria-label": props.config.label, title: props.config.label }), StartIcon ? React.createElement(StartIcon, null) : undefined)) : (React.createElement(Button, Object.assign({}, commonProps, { sx: {
            whiteSpace: ((_e = props.config.style) === null || _e === void 0 ? void 0 : _e.noWrap) ? 'nowrap' : undefined,
        }, variant: 'outlined', startIcon: StartIcon ? React.createElement(StartIcon, null) : undefined }), props.config.label));
    return (React.createElement(Box, { sx: { textAlign: (_f = props.config.style) === null || _f === void 0 ? void 0 : _f.align } },
        React.createElement(FormTooltip, { tooltip: props.config.tooltip }, buttonElement)));
};
const WidgetFormButtonEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: 'Button: ' + props.config.label,
        }, buildGeneralTab(props, {
            keyOptional: true,
            label: true,
            tooltip: true,
            autoFocus: true,
            children: [
                {
                    type: 'form.iconPicker',
                    key: 'icon',
                    label: 'Icon',
                },
                {
                    type: 'form.button',
                    label: 'Clear Icon',
                    event: {
                        onClick: (handler) => {
                            var _a;
                            (_a = handler.up().down('icon')) === null || _a === void 0 ? void 0 : _a.setData(undefined);
                        },
                    },
                },
            ],
        }), buildHiddenTab(props), buildStyleTab(props, {
            align: true,
            children: [
                { type: 'form.checkbox', label: 'No Text Wrap', key: 'style.noWrap' },
                {
                    type: 'form.radio',
                    key: 'style.type',
                    label: 'Button Type',
                    values: [
                        {
                            label: 'Button',
                            value: 'button',
                        },
                        {
                            label: 'Icon As A Button',
                            value: 'iconButton',
                        },
                    ],
                    defaultValue: 'button',
                },
            ],
        }), buildEventTab(props, { eventOnClick: true })) }),
        React.createElement(WidgetFormButton, Object.assign({}, props))));
};
export const widgetFormButton = {
    type,
    update: handleWidgetUpdate,
    component: WidgetFormButton,
    icon: React.createElement(SquareIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormButtonEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, {
        type,
        label: 'Button',
    }),
};
